// 配置文件
//  (地址配置均以/结尾，后续无需再加)

// 开发环境 (dev)
let apiHost = null

const setConfig = () => {
  // apiHost = 'http://116.198.216.54:21021'
  apiHost = 'http://116.198.216.54:21021'
  // 开发线上环境 (develop)
  if (process.env.VUE_APP_ENV && process.env.VUE_APP_ENV === 'dev') {
    apiHost = 'http://116.198.216.54:21021'
  }

  // 测试环境 （test / preview）
  if (process.env.VUE_APP_ENV && process.env.VUE_APP_ENV === 'build') {
    apiHost = 'http://116.198.216.54:21021'
  }

  // 生产环境 （master）
  if (process.env.VUE_APP_ENV && process.env.VUE_APP_ENV === 'build') {
    apiHost = 'http://116.198.216.54:21021'
  }

  // apiHost = 'http://localhost:21021'
}

setConfig()

const tokenName = 'Abp.AuthToken'

//  设置 当前用户的access_token
const setToken = (token) => {
  sessionStorage.setItem(tokenName, token)
}

//  获取 当前用户的access_token
const getToken = () => sessionStorage.getItem(tokenName)

//  删除 当前用户的access_token
const removeToken = () => {
  sessionStorage.removeItem(tokenName)
}

// console.log(process.env.VUE_APP_ENV);

export default {
  apiHost,
  tokenName,
  refreshToken: 'refresh_token',
  setToken, //  设置 当前用户的access_token
  getToken, //  获取 当前用户的access_token
  removeToken //  删除 当前用户的access_token
}
